import { Icon, Tooltip, typography } from '@joor/design-system'
import styled from 'styled-components'

export const NavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 24px;
  background-color: var(--color-secondary-200);
`

export const DetailContainer = styled.div`
  display: flex;
  margin: 5px 16px 0px 16px;
`

export const DetailsWrapper = styled.div`
  flex-wrap: wrap;
  height: 100%;
  width: 90%;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 14px 0;
  background-color: var(--color-secondary-100);
  border: 1px solid var(--color-primary-100);
  border-radius: 10px;

  .inner-item {
    border-left: 1px solid var(--color-primary-100);
    padding: 0 32px;
  }
  .item-left {
    padding: 0 32px;
  }
  .item-default {
    width: 100%;
    max-width: 250px;
  }
  .item-sm {
    flex: 25;
  }
  .item-md {
    flex: 30;
  }
  .item-lg {
    flex: 40;
  }
`

export const DetailItem = styled.div`
  height: 100%;
`

export const DetailTitle = styled.span`
  margin-bottom: 4px !important;
  font-size: var(--size-font-small);
  line-height: 16px;
  letter-spacing: var(--letter-spacing-tighter);
  color: var(--color-primary-400);
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-family-alpha) !important;

  &.error {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &.orphan-retailer-title {
    display: flex;
    gap: 4px;
  }
`

export const DetailValue = styled.p`
  line-height: 16px;
  margin-bottom: 0 !important;
  ${typography.alpha.primaryActive.subtitle3}
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const StyledIcon = styled(Icon)`
  svg {
    --main-color: var(--color-secondary-800);
  }
`

export const LastUpdatedInfo = styled.div`
  ${typography.alpha.primaryActive.caption}
  font-weight: var(--font-weight-regular);
  color: var(--color-primary-800);
  font-style: italic;
`
export const OrderName = styled.div`
  ${typography.alpha.primaryActive.subtitle1}
`

export const CancelOrderLabel = styled.div`
  align-items: center;
  gap: 8px;
  color: var(--color-error-700);
  > span {
    display: flex;
  }
  svg {
    --main-color: var(--color-error-700);
  }
`

export const ErrorField = styled.span`
  color: var(--color-error-600);
`

export const StyledTooltip = styled(Tooltip)`
  align-self: center;
`
